import { MTextField, ResponsiveFormContainer } from "@app/components";

const TiposUnidadesForm = () => {
  return (
    <>
      <ResponsiveFormContainer columns={4}>
        <MTextField
          key={"codigo"}
          name={"codigo"}
          label={"Código"}
          type="text"
          fullWidth
          validation={{ required: `El campo código es requerido` }}
        />

        <MTextField
          key={"descripcion"}
          name={"descripcion"}
          label={"Descripción"}
          type="text"
          fullWidth
          validation={{ required: `El campo descripción es requerido` }}
        />
        <MTextField
          key={"unidades"}
          name={"unidades"}
          label={"Unidades"}
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default TiposUnidadesForm;
